<template>
  <div class="wt-brands-dropdown" v-if="showBrandsList">
    <wt-dropdown
      :items="brandsList"
      :current-item-id="currentBrand ? currentBrand._mixedId : null"
      :type="type"
      :disabled="disabled || disableDropdown"
      :on-click-item="changeBrand"
    >
      <template v-slot:item="{ item }">
        <span v-text-right>{{ item.label }}</span>
      </template>
    </wt-dropdown>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'wt-brands-dropdown',

  props: {
    currentBrand: { type: Object, default: null },
    organizationId: { type: Number, default: null },
    filterByAspectRatio: { type: String, default: '' },
    showSingle: { type: Boolean, default: false },
    enableStash: { type: Boolean, default: false },
    type: { type: String, default: 'underline fixed' },
    disableDropdown: { type: Boolean, default: false },
  },

  computed: {
    ...mapState('user', ['organizations']),
    ...mapGetters('user', ['selectedOrganization']),

    currentOrganization() {
      return this.organizationId
        ? this.organizations.find(
            (org) => org.organizationId === this.organizationId
          )
        : this.selectedOrganization;
    },

    brandsList() {
      let brands = this.currentOrganization.brands;

      if (this.filterByAspectRatio) {
        brands = brands.filter((brand) =>
          brand.themes.find(
            (theme) => theme.aspectRatio === this.filterByAspectRatio
          )
        );
      }

      return brands.map((brand) => {
        return { id: brand._mixedId, label: brand.name };
      });
    },

    disabled() {
      return this.brandsList.length === 1;
    },

    showBrandsList() {
      return this.brandsList.length > (this.showSingle ? 0 : 1);
    },
  },

  watch: {
    organizationId() {
      this.setInitialId();
    },
  },

  created() {
    this.setInitialId();
  },

  methods: {
    setInitialId() {
      let mixedId = this.enableStash
        ? app.stash.get('last-selected-brand')
        : this.currentBrand?._mixedId || null;
      const found = this.brandsList.find((brand) => brand.id === mixedId);

      if (found) {
        this.changeBrand(mixedId);
      } else {
        mixedId = this.brandsList.length ? this.brandsList[0].id : null;
        this.changeBrand(mixedId);
      }
    },

    changeBrand(mixedId) {
      const brand = this.currentOrganization.brands.find(
        (brand) => brand._mixedId === mixedId
      );
      this.$emit('update:currentBrand', brand || null);
      console.$log('brand', brand);

      if (this.enableStash && mixedId) {
        app.stash.set('last-selected-brand', mixedId);
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
